enum GroupsDashTabId {
    Mail = "Mail",
    Files = "Files",
    Events = "Events",
    Members = "Members"
}

export default GroupsDashTabId;
